exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.right-float[data-v-645960cd] {\n  float: right;\n}\n\n", ""]);

// exports
